import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/financial-access-desktop.webp';
import mobileImageWebp from './images/financial-access-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => (
  <HeroSectionStyled
    sectionId='sustainability-impact-financial-access-hero'
    productName='Sustainability and Impact'
    headingText={<>Delivering financial security and expanding <WidowBlock>financial access.</WidowBlock></>}
    descriptionText='Supporting the long&#45;term financial health of our policyowners, clients, and community members is at the core of what we do.'
    ctaPrimary={{
      linkUrl: '/assets/pdf/sustainability/2024-sustainability-and-impact-report.pdf',
      buttonText: 'Read the report',
      ariaLabel: 'Read the 2024 sustainability report.',
      isInternalPdf: true,
      children: '',
    }}
    backgroundImageAriaLabel='Two gentlemen and a lady sitting together and having coffee'
    backgroundImageDesktop={desktopImageWebp.toString()}
    backgroundImageMobile={mobileImageWebp.toString()}
    backgroundImageDesktopLowRes={lowResImageDesktop}
    backgroundImageMobileLowRes={lowResImageMobile}
    backgroundVariant='lightB'
    themeType='lightTheme'
  />
);
